import { useLoaderData } from "react-router-dom";
import { ReactComponent as IconCarrot } from "../../assets/icons/carrot.svg";
import "./spenden.style.scss";

export const Spenden = ({ data }) => {
    const loaderData = useLoaderData();
    const config = data || loaderData?.spenden;

    if (!config) return null;

    const {
        id = "spenden",
        headline,
        subHeadline,
        buttonText,
        buttonLink,
        description,
        qrLabel,
        bgImage,
        qrImage
    } = config;

    return (
        <section className="section section-spenden" id={id}>
            <div className="section-spenden_bg">
                {bgImage && <img src={bgImage} alt="Möhrenscheiben Spenden" className="spenden_bg_img" />}
            </div>
            <div className="section-spenden_container">
                <div className="spenden_top" data-aos="fade-up">
                    {headline && <h2 className="spenden_headline">{headline}</h2>}
                    {subHeadline && (
                        <div 
                            className="spenden_subheadline" 
                            dangerouslySetInnerHTML={{ __html: subHeadline }} 
                        />
                    )}
                    {buttonText && buttonLink && (
                        <div className="spenden_action">
                            <a
                                href={buttonLink}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="spenden_btn"
                            >
                                <span className="spenden_btn_carrot icon-carrot">
                                    <IconCarrot />
                                </span>
                                <span className="spenden_btn_text">{buttonText}</span>
                            </a>
                        </div>
                    )}
                </div>

                <div className="spenden_bottom" data-aos="fade-up">
                    <div className="spenden_description">
                        <div dangerouslySetInnerHTML={{ __html: description }} />
                    </div>

                    <div className="spenden_qr_wrapper">
                        {qrLabel && <div className="spenden_qr_label">{qrLabel}</div>}
                        {qrImage && (
                            <div className="spenden_qr_box">
                                <img src={qrImage} alt="QR Code Spenden" className="spenden_qr_img" />
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Spenden;
